<template>
  <div class="modal-message">
    <div class="card" v-loading="loading" element-loading-spinner="qc-spinner">
      <div class="card-header">
        <h4 class="card-title">Archive Applicants History?</h4>
      </div>
      <div class="card-content">
        <p>Are you sure you want to archive these {{$store.state.applicantSelectedRows.length}} applications?</p>
        <p>This will also notify the applicants you have reviewed their application.</p>
      </div>
      <div class="card-footer row">
        <div class="col-md-12">
          <button @click="$modal.close()" class="btn btn-wd">{{closeText}}</button>
          <button @click="archiveApplications()" class="btn btn-fill btn-wd pull-right">Archive All</button>
        </div>
      </div>
    </div>
  </div>
</template>
  
<script>
export default {
  name: 'modal-message',
  data() {
    return {
      loading: false
    }
  },
  props: {
    title: String,
    description: String,
    message: String,
    closeText: { type: String, default: "Close" },
    actionText: { type: String },
    action: { type: Function }
  },
  methods: {
    archiveApplications() {
      const applicantIdArray = this.$store.state.applicantSelectedRows
      for (let i = 0; i < applicantIdArray.length; i++) {
        this.$api.updateApplication(applicantIdArray[i], { status: 'ARCHIVED' })
      }
      this.$store.state.reloadApplicantHistoryTable = true;
      this.$store.state.applicantSelectedRows = [];
      this.$modal.close();
    }
  }
}
</script>
  
<style>
.modal-message {
  display: flex;
  justify-content: center;
  align-items: center;
}
</style>